import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { Formik, ErrorMessage, Form, Field } from 'formik'
import { requestNewPassword, fetchUser } from '../../actions'

const inputStyle = {
  marginBottom: '10px'
}

class LoginRequestPassword extends Component {

  componentDidMount() {
 		//this.props.actions.fetchUser();
	}

  render() {

    var initValues = {
      email: ''
    };

    return (
      <div>
        <h2>Passwort-Link anfordern</h2>
        <Formik
          initialValues={initValues}
          enableReinitialize
          validate={(values, touched) => {
            let errors = {};
            if (!values.email) {
              errors.email = 'Angabe erforderlich';
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              console.log("submitting new password request");
              this.props.actions.requestNewPassword( values, this.props.history );
              setSubmitting(false);
          }}
        >

          {({ isSubmitting, props, setFieldValue, initValues, values, touched, errors }) => (

            <Form
              onKeyPress={e =>{
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}>
              <label htmlFor="Email">Email</label>
              <Field
                name="email"
                type="text"
                style={inputStyle}
                placeholder="Ihre Email-Adresse"
              />
              <ErrorMessage
                style={{color: 'orange'}}
                name="email"
                component="div"
              />
            <Link to="/login" style={{marginRight: '10px'}} type="cancel">
                <button className="btn btn-secondary" >
                  <span style={{color: 'white'}}>Abbrechen</span>
                </button>
              </Link>
                <button className="btn btn-default" type="submit" disabled={isSubmitting || !values.email}>
                Absenden
              </button>
            </Form>
          )}
        </Formik>

        <div style={{height: "80px"}}></div>

      </div>
    )}
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ fetchUser, requestNewPassword }, dispatch)
  }
}

function mapStateToProps({auth}) {
	return { auth }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginRequestPassword);



// WEBPACK FOOTER //
// ./src/components/login/LoginRequestPassword.js